import React, { useEffect, useState } from 'react';
const navLinks = [{
  label: 'Inicio',
  href: '#top'
}, {
  label: 'Servicios',
  href: '#services'
}, {
  label: 'Galería',
  href: '#gallery'
}, {
  label: 'Testimonios',
  href: '#testimonios'
}, {
  label: 'Ubicación',
  href: '#location'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Lock body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    if (href === '#top') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    setTimeout(() => {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }, 100);
  };
  return <>
      <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300" style={{
      backgroundColor: scrolled || menuOpen ? 'rgba(0,0,0,0.98)' : '#000000',
      borderBottom: '1px solid rgba(201,168,76,0.25)',
      backdropFilter: 'blur(8px)'
    }} data-id="element-146">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16 sm:h-20" data-id="element-147">
          {/* Logo */}
          <a href="#" onClick={() => handleNavClick('#top')} aria-label="By Guerra BarberShop - Home" data-id="element-148">
            <img src="https://cdn.magicpatterns.com/uploads/goqK8pHAvhVgWADmkNvCK7/logobyguerra.png" alt="By Guerra BarberShop" className="h-10 sm:h-12 w-auto object-contain" data-id="element-149" />
          </a>

          {/* Desktop right side */}
          <div className="hidden sm:flex items-center gap-4 sm:gap-6" data-id="element-150">
            {/* Hours badge */}
            <div className="flex items-center gap-2" data-id="element-151">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-152">
                <circle cx="12" cy="12" r="10" data-id="element-153" />
                <polyline points="12 6 12 12 16 14" data-id="element-154" />
              </svg>
              <span style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.8rem',
              color: '#888'
            }} data-id="element-155">
                Open until{' '}
                <span style={{
                color: '#C9A84C',
                fontWeight: 600
              }} data-id="element-156">
                  8PM
                </span>
              </span>
            </div>
            {/* Phone */}
            <a href="tel:7865364035" className="flex items-center gap-2 transition-opacity hover:opacity-80" aria-label="Call us at (786) 536-4035" data-id="element-157">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-158">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-159" />
              </svg>
              <span style={{
              fontFamily: 'var(--font-callout)',
              fontWeight: 600,
              fontSize: '0.95rem',
              color: '#C9A84C',
              letterSpacing: '0.03em'
            }} data-id="element-160">
                (786) 536-4035
              </span>
            </a>
            {/* CTA */}
            <a href="#location" className="btn-gold inline-flex items-center gap-2 px-4 py-2 text-sm rounded-sm" data-id="element-161">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-162">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" data-id="element-163" />
                <circle cx="12" cy="10" r="3" data-id="element-164" />
              </svg>
              Walk In Today
            </a>
          </div>

          {/* Mobile right: phone + hamburger */}
          <div className="flex sm:hidden items-center gap-3" data-id="element-165">
            <a href="tel:7865364035" className="flex items-center gap-1.5" aria-label="Call (786) 536-4035" data-id="element-166">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-167">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-168" />
              </svg>
              <span style={{
              fontFamily: 'var(--font-callout)',
              fontWeight: 600,
              fontSize: '0.8rem',
              color: '#C9A84C'
            }} data-id="element-169">
                536-4035
              </span>
            </a>

            {/* Hamburger button */}
            <button onClick={() => setMenuOpen(o => !o)} className="flex flex-col justify-center items-center w-9 h-9 gap-1.5" aria-label={menuOpen ? 'Close menu' : 'Open menu'} aria-expanded={menuOpen} data-id="element-170">
              <span style={{
              display: 'block',
              width: '22px',
              height: '1.5px',
              backgroundColor: '#C9A84C',
              transition: 'transform 0.3s ease, opacity 0.3s ease',
              transform: menuOpen ? 'translateY(5px) rotate(45deg)' : 'none'
            }} data-id="element-171" />
              <span style={{
              display: 'block',
              width: '22px',
              height: '1.5px',
              backgroundColor: '#C9A84C',
              transition: 'opacity 0.3s ease',
              opacity: menuOpen ? 0 : 1
            }} data-id="element-172" />
              <span style={{
              display: 'block',
              width: '22px',
              height: '1.5px',
              backgroundColor: '#C9A84C',
              transition: 'transform 0.3s ease, opacity 0.3s ease',
              transform: menuOpen ? 'translateY(-5px) rotate(-45deg)' : 'none'
            }} data-id="element-173" />
            </button>
          </div>
        </div>

        {/* Mobile dropdown menu */}
        <div className="sm:hidden overflow-hidden" style={{
        maxHeight: menuOpen ? '400px' : '0',
        transition: 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        borderTop: menuOpen ? '1px solid rgba(201,168,76,0.15)' : 'none'
      }} data-id="element-174">
          <nav aria-label="Mobile navigation" data-id="element-175">
            <ul className="py-2" data-id="element-176">
              {navLinks.map((link, i) => <li key={link.href} data-id="element-177">
                  <button onClick={() => handleNavClick(link.href)} className="w-full flex items-center justify-between px-5 py-4 transition-all" style={{
                borderBottom: i < navLinks.length - 1 ? '1px solid rgba(201,168,76,0.08)' : 'none'
              }} onMouseEnter={e => {
                ;
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'rgba(201,168,76,0.05)';
              }} onMouseLeave={e => {
                ;
                (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'transparent';
              }} data-id="element-178">
                    <span style={{
                  fontFamily: 'var(--font-callout)',
                  fontSize: '1rem',
                  fontWeight: 500,
                  color: '#F5F5F5',
                  letterSpacing: '0.05em',
                  textTransform: 'uppercase'
                }} data-id="element-179">
                      {link.label}
                    </span>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-180">
                      <polyline points="9 18 15 12 9 6" data-id="element-181" />
                    </svg>
                  </button>
                </li>)}
            </ul>
            {/* Mobile CTA */}
            <div className="px-5 py-4" data-id="element-182">
              <a href="#location" onClick={() => handleNavClick('#location')} className="btn-gold w-full flex items-center justify-center gap-2 py-3 text-sm rounded-sm" data-id="element-183">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-184">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" data-id="element-185" />
                  <circle cx="12" cy="10" r="3" data-id="element-186" />
                </svg>
                Walk In Today — Open Until 8PM
              </a>
            </div>
          </nav>
        </div>
      </header>
    </>;
}